/* unplugin-vue-components disabled */import { render } from "./PromotionRecord.vue?vue&type=template&id=f50cfd0c&scoped=true"
import script from "./PromotionRecord.vue?vue&type=script&lang=js"
export * from "./PromotionRecord.vue?vue&type=script&lang=js"

import "./PromotionRecord.vue?vue&type=style&index=0&id=f50cfd0c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f50cfd0c"]])

export default __exports__